import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormlyModule } from '@ngx-formly/core';
import { DefaultWrapperComponent } from './default-wrapper.component';

@NgModule({
  declarations: [DefaultWrapperComponent],
  imports: [
    CommonModule,
    FormlyModule.forChild({
      wrappers: [
        {
          name: 'default',
          component: DefaultWrapperComponent,
        },
      ],
    }),
  ],
})
export class DefaultWrapperModule {}
